import {useEffect, useState} from "react";
import axios from "axios";
import {buyeeUrl} from "utils/url";

const SearchForm = () => {
  const YAHOO_ROOT_CATEGORY_ID = 0;
  const YAHOO_ROOT_CATEGORY_LABEL = '所有類別';
  const TRANSLATION_TYPE_CN = 2;
  const TRANSLATION_TYPE_JP = 1;

  const [categories, setCategories] = useState([]);
  const [isCategoryExpanded, setIsCategoryExpanded] = useState(false);
  const [categoryLabel, setCategoryLabel] = useState(YAHOO_ROOT_CATEGORY_LABEL);
  const [selectedCategory, setSelectedCategory] = useState(YAHOO_ROOT_CATEGORY_ID);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    axios
      .get('files/cobrand/yahoo_auction_categories.json')
      .then(response => {
        setCategories(response.data);
      });
  }, []);

  const selectCategory = (categoryId, categoryLabel) => {
    setSelectedCategory(categoryId);
    setCategoryLabel(categoryLabel);
    setIsCategoryExpanded(false);
  };

  const search = (translationType) => {
    const query = keyword.trim();

    if (query === '' && selectedCategory === YAHOO_ROOT_CATEGORY_ID) {
      return;
    }

    let url;
    if (query === '') {
      url = buyeeUrl(`item/search/category/${selectedCategory}?lang=cht&rc=twy_cobrand_entry&twTran=1`);
    } else if (selectedCategory === YAHOO_ROOT_CATEGORY_ID) {
      url = buyeeUrl(`item/search/query/${query}?translationType=${translationType}&lang=cht&rc=twy_cobrand_entry&twTran=1`);
    } else {
      url = buyeeUrl(`item/search/query/${query}/category/${selectedCategory}?translationType=${translationType}&lang=cht&rc=twy_cobrand_entry&twTran=1`);
    }

    window.location.href = url;
  };

  return (
    <div className="tw-top__search width-full">

      {/* PC検索窓 */}
      <form className="display-none--s tw-search__box" data-bind="submit: keywordSearch.bind($data, {})">
        <div className="search-box search-box__pc">
          <div className="search-select" onClick={() => setIsCategoryExpanded(!isCategoryExpanded)}>
            <span className="category-label">{categoryLabel}</span>
            <span className={isCategoryExpanded ? 'toggle-close' : 'toggle-open'}>
              <i className="icon solid-arrow"></i>
            </span>
          </div>
          <div className="search-textarea">
            <input type="text" name="query" placeholder="&#xe900; 搜尋商品" maxLength="1000"
                   value={keyword} onChange={e => setKeyword(e.target.value)}/>
            <button type="button" className="search-cancel icon remove" onClick={() => setKeyword('')}></button>
          </div>
        </div>
        <div className="search-button--group">
          <button type="button" className="btn btn--search" onClick={() => search(TRANSLATION_TYPE_CN)}>中文搜尋</button>
          <button type="button" className="btn btn--search" onClick={() => search(TRANSLATION_TYPE_JP)}>原文搜尋</button>
        </div>
        <div className={"searchcategory cat_expanded display-none--s " + (isCategoryExpanded ? "toggle-open" : "")}>
          <div className="searchcategory-block width-contents clearfix">
            <button type="button" className="searchcategory-btn-close" onClick={() => setIsCategoryExpanded(false)}>
              <i className="icon close"></i>
            </button>
            <ul className="searchcategory-lists">
              <li className="list">
                <a className={selectedCategory === YAHOO_ROOT_CATEGORY_ID ? "cat_selected" : ""} title={YAHOO_ROOT_CATEGORY_LABEL}
                   onClick={() => selectCategory(YAHOO_ROOT_CATEGORY_ID, YAHOO_ROOT_CATEGORY_LABEL)}>
                  {YAHOO_ROOT_CATEGORY_LABEL}
                </a>
              </li>
              {categories.map(category =>
                <li className="list" key={category.id}>
                  <a title={category.name} className={selectedCategory === category.id ? "cat_selected" : ""}
                     onClick={e => selectCategory(category.id, category.name)}>
                    {category.name}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </form>

      {/* SP検索窓 */}
      <form method="post" className="display-show--s tw-search__box">
        <div className="search-box">
          <div className="select-category">
            <span className="selectbox">
              <select value={selectedCategory}
                      onChange={e => selectCategory(e.target.value, e.target.selectedOptions[0].innerHTML)}>
                <option value={YAHOO_ROOT_CATEGORY_ID}
                        onClick={() => selectCategory(YAHOO_ROOT_CATEGORY_ID, YAHOO_ROOT_CATEGORY_LABEL)}>{YAHOO_ROOT_CATEGORY_LABEL}</option>
                {categories.map(category =>
                  <option key={category.id} value={category.id}
                          onClick={() => selectCategory(category.id, category.name)}>{category.name}</option>
                )}
              </select>
            </span>
            <span className="category-label">{categoryLabel}</span>
          </div>
          <div className="search-textarea">
            <input type="text" name="query" placeholder="&#xe900; 搜尋商品" maxLength="1000"
                   value={keyword} onChange={e => setKeyword(e.target.value)}/>
            <button type="button" className="search-cancel icon remove" onClick={() => setKeyword('')}></button>
          </div>
        </div>
        <div className="search-button--group">
          <button type="button" className="btn btn--search" onClick={() => search(TRANSLATION_TYPE_CN)}>中文搜尋</button>
          <button type="button" className="btn btn--search" onClick={() => search(TRANSLATION_TYPE_JP)}>原文搜尋</button>
        </div>
      </form>

    </div>
  );
};

export default SearchForm;
